//system
export const API_IP = '/ip';
export const API_FP = '/fp';
export const API_TIME = '/time';

//Auth
export const API_AUTH_LOGIN = '/auth/signin';
/** Đăng nhập client — POST body { username, lastbank, site } */
export const API_AUTH_CLIENT_SIGNIN = '/auth/client-signin';

//Users
export const API_USERS_TOKEN = '/users/token';
export const API_USERS_NEW88_CHECK = '/predictions/many';
export const API_USERS_SHBET_CHECK = '/users/shbet/check';

//Match
export const API_MATCHS = '/matchs';
export const API_MATCHS_DATE = '/matchs/date';
export const API_MATCHS_BY_DATE = '/match/match-date';
export const API_MATCHS_LIST = '/match/list-match';
export const API_MATCHS_RESULT_LIST = '/match/getMatchResultList';

//Prediction
export const API_PREDICTIONS = '/predictions';
export const API_PREDICTIONS_MANY = '/predictions/many';
export const API_PREDICTIONS_GET = '/predictions/get';
export const API_PREDICTIONS_CLAIM_REWARD = '/predictions/claim-reward';

// World Cup / OK9-style catalog (api-ddts-sc88.attcloud.org)
export const API_TEAMS = '/teams';
/** GET — danh sách đội Châu Á (World Cup) */
export const API_TEAMS_ASIA = '/teams/asia';
export const API_PLAYERS = '/players';
export const API_TEAMS_CHAMPIONS = '/worldcup/teams-champions';
export const API_WORLD_CUP_CHAMPION = '/worldcup/champion';
/** GET thống kê | POST dự đoán — đội Châu Á vào sâu nhất */
export const API_WORLD_CUP_FINAL_ASIA_TEAM = '/worldcup/final-asia-team';
/** GET thống kê | POST dự đoán — đội ghi nhiều bàn nhất trong 1 trận */
export const API_WORLD_CUP_BEST_TEAM_GOAL_IN_MATCH = '/worldcup/best_team_goal_in_match';
export const API_TOP_SCORER_PREDICTIONS = '/worldcup/top-scorer-predictions';
export const API_BEST_PLAYER_PREDICTIONS = '/worldcup/best-player-predictions';
// Bình chọn (vote) vua phá lưới
export const API_WORLD_CUP_TOP_SCORER = '/worldcup/top-scorer';

// Bình chọn (vote) cầu thủ xuất sắc nhất
export const API_WORLD_CUP_BEST_PLAYER = '/worldcup/best-player';
export const API_WORLD_CUP_HISTORY_PREDICTIONS_ACCOUNT = '/worldcup/history-predictions-account';

//Settings
export const API_SETTINGS = '/settings';

//Banner
export const API_BANNER = '/banner';
//LUONGSONTV
export const API_MATCH_SCHEDULE = 'match-schedule';

//Files
export const API_FILES = '/file';
